<template>
  <Command v-if="alwaysShown || mediaPlayer === TTSEngine" @click="trigger">
    <slot
      v-bind="{
        disabled: false,
        icon: 'tune',
        label: t('tts.settings.title'),
        toolTip: t('tts.settings.title'),
      }"
    />
  </Command>
</template>
<script setup lang="ts">
import { inject, Ref } from "vue";
import { useI18n } from "vue-i18n";

import { posthogKeys } from "@/helpers/constants";
import { usePostHog } from "@/helpers/posthog";
import MediaPlayer from "@/services/media/player";
import TTSEngine from "@/services/tts/TTSEngine";

import SettingsTTS from "@/components/tts/SettingsTTS.vue";
import {
  OverlayType,
  TransitionType,
  useUILayers,
} from "@/components/UILayers";

import Command from "../command";

defineProps<{ alwaysShown?: boolean }>();

const { t } = useI18n();
const { capture: capturePosthogEvent } = usePostHog();

const { add } = useUILayers();

const mediaPlayer = inject("mediaPlayer") as Ref<MediaPlayer>;

function trigger() {
  add(
    SettingsTTS,
    {},
    {
      overlay: OverlayType.Transparent,
      transition: TransitionType.SlideLeftMobileUp,
    }
  );
  capturePosthogEvent(posthogKeys.ttsSettings);
}
</script>
